import { Component, OnInit } from '@angular/core';
import { CityModel, HxProductInfoService, HxStoreProductService, HxUiLabelPipe, ProductInfoModel, StoreBasicModel, StoreProductModel } from 'hx-services';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { FormsModule, UntypedFormBuilder } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NgFor, NgIf } from '@angular/common';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzSwitchComponent } from 'ng-zorro-antd/switch';

interface Reservation {
  city: CityModel;
  storeProducts: ReservationProduct[];
}

interface ReservationProduct {
  storeProduct?: StoreProductModel;
  store: StoreBasicModel;
  reservedAmount: number;
  checked?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

@Component({
    selector: 'hc-product-definition-sync',
    templateUrl: './product-definition-sync.component.html',
    styleUrls: ['./product-definition-sync.component.less'],
    imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, TranslocoDirective, NzSkeletonComponent, NgFor, NzRowDirective, NzDividerComponent, NzColDirective, NzTooltipDirective, NzSwitchComponent, FormsModule, NgIf, HxUiLabelPipe, TranslocoPipe]
})
export class ProductDefinitionSyncComponent implements OnInit {
  model!: ProductInfoModel;

  storeProducts: Reservation[] = [];
  isLoading = {
    storeProducts: false,
  };
  private readonly path = 'product-definitions';

  constructor(
    private storeProductService: HxStoreProductService,
    protected aRoute: ActivatedRoute,
    protected fb: UntypedFormBuilder,
    protected productService: HxProductInfoService,
    protected router: Router,
    protected modal: NzModalService,
    protected notification: NzNotificationService,
    protected tr: TranslocoService,
  ) {
  }

  ngOnInit(): void {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['model'] as ProductInfoModel;
    this.loadStoreProducts();
  }

  syncStoreProduct(rp: ReservationProduct) {
    rp.loading = true;
    this.storeProductService.syncStoreProduct({storeId: rp.store.id, productInfoId: this.model.id}).subscribe(() => {
      rp.loading = false;
      rp.checked = !rp.checked;
      this.notification.success(this.tr.translate('nav.ProductDefinitions'), this.tr.translate('nt.dataSaved'));
    }, err => {
      rp.loading = false;
      this.notification.error(this.tr.translate('nav.ProductDefinitions'), this.tr.translate('nt.error'));
    });
  }

  private loadStoreProducts() {
    this.isLoading.storeProducts = true;
    this.storeProductService.getStoreProductGroupedByStoreId(this.model.id).subscribe(storeProducts => {
      const list = storeProducts as Reservation[];
      list.forEach(res => res.storeProducts.forEach(sp => {
        sp.checked = sp.storeProduct !== undefined && sp.storeProduct.enabled && !sp.storeProduct.removed;
        sp.disabled = (sp.storeProduct !== undefined && sp.storeProduct.amount > 0) || sp.reservedAmount > 0;
        sp.loading = false;
      }));
      this.storeProducts = list;
      this.isLoading.storeProducts = false;
    }, err => this.isLoading.storeProducts = false);
  }
}
